import { MESSAGE_PREFIX } from '@klausapp/extension/src/utils/messaging'
export { MESSAGE_PREFIX } from '@klausapp/extension/src/utils/messaging'

export const EXT_ID_KEY = 'zqaExtId'
export const TAB_ID_KEY = 'zqaTabId'

export function getExtId(): string | null {
  return sessionStorage.getItem(EXT_ID_KEY)
}

function getTabId(): string | null {
  return sessionStorage.getItem(TAB_ID_KEY)
}

export const sendMessage = (message: string, data?: unknown) => {
  const extId = getExtId()
  if (extId && 'chrome' in window && chrome.runtime) {
    const tabId = getTabId()
    chrome.runtime.sendMessage(extId, { type: `${MESSAGE_PREFIX}${message}`, data, tabId }).catch((_e: unknown) => {
      // extension may be reloading or unavailable
    })
  } else {
    // TODO(ext-v3): remove — v2 relayed messages via postMessage to the parent iframe
    top?.window.postMessage({ type: `${MESSAGE_PREFIX}${message}`, data }, '*')
  }
}

export const connectPort = (): chrome.runtime.Port | null => {
  const extId = getExtId()
  const tabId = getTabId()
  if (!extId || !tabId || !('chrome' in window) || !chrome.runtime) return null
  try {
    return chrome.runtime.connect(extId, { name: `zqa-panel-${tabId}` })
  } catch {
    return null
  }
}

// TODO(ext-v3): remove — v2 used appLoaded to sync allowedHosts/hasSession to extension storage
export const shareHostsWithExtension = (hosts?: string[]) => {
  sendMessage('appLoaded', { authenticated: !!hosts, hosts })
}
